export default {
  "List": [
    {
      "path": "/",
      "code": "",
      "children": [
        {
          "path": "/consultation",
          "code": "",
          "children": [
            {
              "path": "/consultation/servicePlaceInfo",
              "code": "",
              "children": [
                {
                  "path": "/transport/consultation/servicePlaceInfo/stationInforQuery",
                  "code": "",
                  "orderIndex": 90,
                  "check": "false",
                  "title": "营业站服务信息查询",
                  "value": "stationInforQuery",
                  "isEnd": "0"
                },
                {
                  "path": "/transport/consultation/servicePlaceInfo",
                  "code": "",
                  "children": [
                    {
                      "path": "/transport/consultation/servicePlaceInfo/stationStopUnloadInfo",
                      "code": "",
                      "orderIndex": 110,
                      "check": "false",
                      "title": "营业站临时停卸装公告",
                      "value": "stationStopUnloadInfo",
                      "isEnd": "0"
                    },
                    {
                      "path": "/transport/consultation/servicePlaceInfo/stationStopUnloadInfo/stationNotice",
                      "code": "",
                      "orderIndex": 120,
                      "check": "false",
                      "title": "公告详情",
                      "value": "stationNotice",
                      "isEnd": "0"
                    }
                  ],
                  "nextIsButton": "0",
                  "orderIndex": 100,
                  "check": "false",
                  "title": "临时停卸装公告",
                  "value": "transport_stationStopUnloadInfo",
                  "isEnd": "0"
                }
              ],
              "nextIsButton": "0",
              "orderIndex": 80,
              "check": "false",
              "title": "服务场所综合信息",
              "value": "servicePlaceInfo",
              "isEnd": "0"
            },
            {
              "path": "/transport/goodRate",
              "code": "",
              "children": [
                {
                  "path": "/transport/goodRate",
                  "code": "",
                  "orderIndex": 140,
                  "check": "false",
                  "title": "货物运价率",
                  "value": "goodRate",
                  "isEnd": "0"
                },
                {
                  "path": "/transport/benchmarkFreightRate",
                  "code": "",
                  "orderIndex": 150,
                  "check": "false",
                  "title": "整车货物装卸费基准费率",
                  "value": "benchmarkFreightRate",
                  "isEnd": "0"
                },
                {
                  "path": "/transport/railIncidentalsCharge",
                  "code": "",
                  "orderIndex": 160,
                  "check": "false",
                  "title": "铁路杂费收费项目和标准",
                  "value": "railIncidentalsCharge",
                  "isEnd": "0"
                },
                {
                  "path": "/transport/goodRateQuery",
                  "code": "",
                  "orderIndex": 170,
                  "check": "false",
                  "title": "货物运费查询",
                  "value": "goodRateQuery",
                  "isEnd": "0"
                }
              ],
              "nextIsButton": "0",
              "orderIndex": 130,
              "check": "false",
              "title": "价格查询",
              "value": "transport_goodRate",
              "isEnd": "0"
            },
            {
              "path": "/transport/gondolaCar",
              "code": "",
              "children": [
                {
                  "path": "/transport/gondolaCar",
                  "code": "",
                  "orderIndex": 190,
                  "check": "false",
                  "title": "敞车",
                  "value": "gondolaCar",
                  "isEnd": "0"
                }
              ],
              "nextIsButton": "0",
              "orderIndex": 180,
              "check": "false",
              "title": "车辆参数",
              "value": "transport_gondolaCar",
              "isEnd": "0"
            },
            {
              "path": "/transport/legalDocument",
              "code": "",
              "children": [
                {
                  "path": "/transport/legalDocument",
                  "code": "",
                  "orderIndex": 210,
                  "check": "false",
                  "title": "法律法规及规范性文件",
                  "value": "legalDocument",
                  "isEnd": "0"
                },
                {
                  "path": "/transport/document",
                  "code": "",
                  "orderIndex": 220,
                  "check": "false",
                  "title": "法律法规及规范性文件详情",
                  "value": "legalDocumentDetail",
                  "isEnd": "0"
                }
              ],
              "nextIsButton": "0",
              "orderIndex": 200,
              "check": "false",
              "title": "法律法规及规范性文件",
              "value": "transport_legalDocument",
              "isEnd": "0"
            },
            {
              "path": "/transport/transportQuestions",
              "code": "",
              "children": [
                {
                  "path": "/transport/transportQuestions",
                  "code": "",
                  "orderIndex": 240,
                  "check": "false",
                  "title": "货运办理常见问题",
                  "value": "transport-transportQuestions",
                  "isEnd": "0"
                },
                {
                  "path": "/transport/questions",
                  "code": "",
                  "orderIndex": 250,
                  "check": "false",
                  "title": "货运办理常见问题详情",
                  "value": "questions_detail",
                  "isEnd": "0"
                }
              ],
              "nextIsButton": "0",
              "orderIndex": 230,
              "check": "false",
              "title": "运输问题",
              "value": "transportQuestions",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 60,
          "check": "false",
          "title": "咨询服务",
          "value": "transport_consultation",
          "isEnd": "0"
        },
        {
          "path": "/msgboard",
          "code": "",
          "children": [
            {
              "path": "/transport/workbench/msgboard",
              "code": "",
              "orderIndex": 90,
              "check": "false",
              "title": "留言板",
              "value": "transport_workbench_msgboard",
              "isEnd": "0"
            },
            {
              "path": "/transport/workbench/msgboardetail",
              "code": "",
              "orderIndex": 90,
              "check": "false",
              "title": "留言板详情",
              "value": "transport_workbench_msgboardetail",
              "isEnd": "0"
            },
            {
              "path": "/transport/workbench/myboard",
              "code": "",
              "orderIndex": 90,
              "check": "false",
              "title": "我的留言板",
              "value": "transport_workbench_myboard",
              "isEnd": "0"
            },
          ],
          "nextIsButton": "0",
          "orderIndex": 60,
          "check": "false",
          "title": "咨询服务",
          "value": "transport_consultation",
          "isEnd": "0"
        }
      ],
      "nextIsButton": "0",
      "orderIndex": 10,
      "check": "false",
      "title": "首页",
      "value": "/index",
      "isEnd": "0"
    },
    {
      "path": "/transport",
      "code": "",
      "children": [
        {
          "path": "/transport/workbench",
          "code": "",
          "children": [
            {
              "path": "/transport/workbench",
              "code": "",
              "orderIndex": 40,
              "check": "false",
              "title": "我的工作台",
              "value": "workbench",
              "isEnd": "0"
            },
            {
              "path": "/transport/workbenchInfo",
              "code": "",
              "orderIndex": 50,
              "check": "false",
              "title": "工作台信息",
              "value": "workbenchInfo",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 30,
          "check": "false",
          "title": "我的工作台",
          "value": "transport_workbench",
          "isEnd": "0"
        },
        {
          "path": "/transport/phaseTransportDemand",
          "code": "",
          "children": [
            {
              "path": "PeriodDemandInfoDel",
              "code": "",
              "orderIndex": 261,
              "check": "false",
              "title": "阶段运输需求删除",
              "value": "PeriodDemandInfoDel",
              "isEnd": "1"
            },
            {
              "path": "PeriodDemandInfoUpd",
              "code": "",
              "orderIndex": 262,
              "check": "false",
              "title": "阶段运输需求修改",
              "value": "PeriodDemandInfoUpd",
              "isEnd": "1"
            },
            {
              "path": "PeriodTurnDayDemand",
              "code": "1",
              "orderIndex": 263,
              "check": "false",
              "title": "阶段需求转日需求",
              "value": "PeriodTurnDayDemand",
              "isEnd": "1"
            },
            {
              "path": "/transport/phaseTransportDemand",
              "code": "",
              "orderIndex": 270,
              "check": "false",
              "title": "阶段运输需求",
              "value": "phaseTransportDemand",
              "isEnd": "0"
            },
            {
              "path": "/transport/phaseTransportDemand/phaseTransportDemandNew",
              "code": "",
              "orderIndex": 280,
              "check": "false",
              "title": "阶段运输需求新建",
              "value": "newPhaseDemand",
              "isEnd": "1"
            },
            {
              "path": "/transport/phaseTransportDemand/phaseTransportDemandRes",
              "code": "",
              "orderIndex": 290,
              "check": "false",
              "title": "阶段运输结果页",
              "value": "resultPhaseDemand",
              "isEnd": "0"
            },
            {
              "path": "/transport/phaseTransportDemand/phaseDemandInfoSupple",
              "code": "",
              "orderIndex": 290,
              "check": "false",
              "title": "阶段信息补充修改",
              "value": "phaseDemandInfoSupple",
              "isEnd": "0"
            },
            {
              "path": "/transport/phaseTransportDemand/phaseTransportDemandDetail",
              "code": "",
              "orderIndex": 300,
              "check": "false",
              "title": "阶段运输详情",
              "value": "phaseTransportDemandDetail",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "1",
          "orderIndex": 260,
          "check": "false",
          "title": "阶段运输需求",
          "value": "transport_phaseTransportDemand",
          "isEnd": "0"
        },
        {
          "path": "/transport/dailyTransportDemand",
          "nextIsButton": "1",
          "orderIndex": 310,
          "check": "false",
          "title": "日运输需求",
          "value": "transport_dailyTransportDemand",
          "isEnd": "0",
          "children": [
            {
              "path": "/transport/dailyTransportDemand",
              "code": "",
              "orderIndex": 320,
              "check": "false",
              "title": "初始化日运输需求页面",
              "value": "dailyTransportDemand",
              "isEnd": "0",
              "btnAuthList": [
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_new",
                  "title": "需求新建按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_export",
                  "title": "导出Excel按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_print",
                  "title": "打印按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_multimodal",
                  "title": "多式联运预定按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_source",
                  "title": "运输资源预定按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_arriveChange",
                  "title": "到达变更按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_unsubscribe",
                  "title": "退订按钮"
                },
              ]
            },
            {
              "path": "/transport/dailyTransportDemand/dailyTransportDemandNew",
              "code": "",
              "orderIndex": 330,
              "check": "false",
              "title": "日需求新建页面",
              "value": "dailyTransportDemandNew",
              "isEnd": "1",
              "btnAuthList": [
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_historyExport",
                  "title": "历史需求导入按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_export",
                  "title": "导入Excel按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_download",
                  "title": "下载模版按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_delete",
                  "title": "批量删除"
                }
              ]
            },
            {
              "path": "/transport/dailyTransportDemand/dailyTransportDemandRes",
              "code": "",
              "orderIndex": 340,
              "check": "false",
              "title": "日需求新建结果页",
              "value": "dailyTransportDemandRes",
              "isEnd": "0"
            },
            {
              "path": "/transport/dailyTransportDemand/dailyTransportDemandDetail",
              "code": "",
              "orderIndex": 350,
              "check": "false",
              "title": "日需求详情页",
              "value": "dailyTransportDemandDetail",
              "isEnd": "0"
            },
            {
              "path": "/transport/dailyTransportDemand/shippingSupplementInfo",
              "code": "",
              "orderIndex": 360,
              "check": "false",
              "title": "托运信息补充页面",
              "value": "shippingSupplementInfo",
              "isEnd": "1"
            },
            {
              "path": "/transport/dailyTransportDemand/transportResourceReservation",
              "code": "",
              "orderIndex": 380,
              "check": "false",
              "title": "运输资源预定页面",
              "value": "resourceReservation",
              "isEnd": "0",
              "btnAuthList": [
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_modify",
                  "title": "修改按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_delete",
                  "title": "删除按钮"
                }
              ]
            },
            {
              "path": "/transport/dailyTransportDemand/multimodalTransport",
              "code": "",
              "orderIndex": 390,
              "check": "false",
              "title": "多式联运页面",
              "value": "daily_dailyTransportDe",
              "isEnd": "0",
              "btnAuthList": [
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_modify",
                  "title": "修改按钮"
                },
                {
                  "forbidden": true,
                  "check": "false",
                  "value": "B_delete",
                  "title": "删除按钮"
                }
              ]
            },
            {
              "path": "/transport/dailyTransportDemand/arriveChange/arriveChangeInput",
              "code": "",
              "orderIndex": 390,
              "check": "false",
              "title": "到达变更录入",
              "value": "arriveChangeInput",
              "isEnd": "0"
            }
          ]
        },
        // {
        //   "path": "/transport/changeRequirement",
        //   "code": "1",
        //   "orderIndex": 315,
        //   "check": "false",
        //   "title": "需求变更",
        //   "value": "changeRequirement",
        //   "isEnd": "0"
        // },
        {
          "path": "/transport/freightCharges",
          "code": "",
          "children": [
            {
              "path": "/transport/freightCharges",
              "code": "",
              "orderIndex": 420,
              "check": "false",
              "title": "运费支付",
              "value": "freightCharges",
              "isEnd": "0"
            },
            {
              "path": "/transport/freightCharges/details",
              "code": "",
              "orderIndex": 430,
              "check": "false",
              "title": "交易明细",
              "value": "freightChargesDetails",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 410,
          "check": "false",
          "title": "运费支付",
          "value": "transport_freightCharges",
          "isEnd": "0"
        },
        {
          "path": "/transport/transport-LoadUnloadVehicleInfo",
          "code": "",
          "orderIndex": 440,
          "check": "false",
          "title": "装卸车信息",
          "value": "loadUnloadVehicleInfo",
          "isEnd": "0"
        },
        {
          "path": "/transport/cargoTracking",
          "code": "",
          "orderIndex": 450,
          "check": "false",
          "title": "货物追踪",
          "value": "transport_cargoTracking",
          "isEnd": "0"
        },
        {
          "path": "/transport/goodsDelivery",
          "code": "",
          "children": [
            {
              "path": "/transport/goodsDelivery",
              "code": "",
              "orderIndex": 470,
              "check": "false",
              "title": "货物交付",
              "value": "transport_goodsDelivery",
              "isEnd": "0"
            },
            {
              "path": "/transport/orderDelivery",
              "code": "",
              "orderIndex": 480,
              "check": "false",
              "title": "交付交割单",
              "value": "transport_orderDelivery",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 460,
          "check": "false",
          "title": "货物交付",
          "value": "delivery",
          "isEnd": "0"
        },
        {
          "path": "/transport/claimSettlementService",
          "code": "",
          "children": [
            {
              "path": "/transport/claimSettlementService",
              "code": "",
              "orderIndex": 500,
              "check": "false",
              "title": "理赔信息",
              "value": "claimSettlementService",
              "isEnd": "0"
            },
            {
              "path": "/transport/claimSettlementService/claimProcess",
              "code": "",
              "orderIndex": 510,
              "check": "false",
              "title": "理赔流程",
              "value": "claimProcess",
              "isEnd": "0"
            },
            {
              "path": "/transport/claimSettlementService/freightRecord",
              "code": "",
              "orderIndex": 520,
              "check": "false",
              "title": "货运记录",
              "value": "freightRecord",
              "isEnd": "0"
            },
            {
              "path": "/transport/claimSettlementService/claimSettlement",
              "code": "",
              "orderIndex": 530,
              "check": "false",
              "title": "申请理赔",
              "value": "claimSettlement",
              "isEnd": "0"
            },
            {
              "path": "/transport/claimSettlementService/customerNotice",
              "code": "",
              "orderIndex": 540,
              "check": "false",
              "title": "查看客户通知书",
              "value": "customerNotice",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 490,
          "check": "false",
          "title": "理赔信息",
          "value": "claimSettlementService",
          "isEnd": "0"
        },
        {
          "path": "/transport/contractManagement_1",
          "btnAuthList": [
            {
              "path": "ContractMaintenanceAdd",
              "code": "",
              "orderIndex": 551,
              "check": "false",
              "title": "合同新增",
              "value": "ContractMaintenanceAdd",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "ContractMaintenanceAdd",
              "code": "",
              "orderIndex": 551,
              "check": "false",
              "title": "合同新增",
              "value": "ContractMaintenanceAdd",
              "isEnd": "1"
            },
            {
              "path": "/transport/contractManagement_1",
              "code": "",
              "orderIndex": 560,
              "check": "false",
              "title": "运输合同",
              "value": "contractManagement",
              "isEnd": "0"
            },
            {
              "path": "/transport/contractManagement_1/contractSigning",
              "code": "",
              "orderIndex": 570,
              "check": "false",
              "title": "合同签订",
              "value": "contractSigning",
              "isEnd": "0"
            },
            {
              "path": "/transport/contractManagement_1/contractModif",
              "code": "",
              "orderIndex": 580,
              "check": "false",
              "title": "合同修改",
              "value": "contrac",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 550,
          "check": "false",
          "title": "合同管理",
          "value": "transport_contractManagement",
          "isEnd": "0"
        }
      ],
      "nextIsButton": "0",
      "orderIndex": 20,
      "check": "false",
      "title": "运输服务",
      "value": "transport",
      "isEnd": "0"
    },
    {
      "path": "/commerce",
      "code": "",
      "children": [
        {
          "path": "/commerce",
          "code": "",
          "children": [
            {
              "path": '/commerce/bidquiry',
              "code": "",
              "orderIndex": 610,
              "check": "false",
              "title": "竞价公告查询",
              "value": "commerce_bidquiry",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 600,
          "check": "false",
          "title": "商贸首页",
          "value": "commerce_index",
          "isEnd": "0"
        },
        {
          "path": "/commerce/listPayable",
          "btnAuthList": [
            {
              "path": "BatGoodsStateUpdate",
              "code": "",
              "orderIndex": 621,
              "check": "false",
              "title": "发布状态修改",
              "value": "BatGoodsStateUpdate",
              "isEnd": "1"
            },
            {
              "path": "BatGoodsAdd",
              "code": "",
              "orderIndex": 622,
              "check": "false",
              "title": "挂单新增",
              "value": "BatGoodsAdd",
              "isEnd": "1"
            },
            {
              "path": "BatGoodsDel",
              "code": "",
              "orderIndex": 623,
              "check": "false",
              "title": "挂单删除",
              "value": "BatGoodsDel",
              "isEnd": "1"
            },
            {
              "path": "BatGoodsUpdate",
              "code": " ",
              "orderIndex": 624,
              "check": "false",
              "title": "挂单修改",
              "value": "BatGoodsUpdate",
              "isEnd": "1"
            },
            {
              "path": "BatGoodsUpdateByState",
              "code": "",
              "orderIndex": 625,
              "check": "false",
              "title": "挂单应单撤销",
              "value": "BatGoodsUpdateByState",
              "isEnd": "1"
            },
            {
              "path": "BatPreOrderAdd",
              "code": "",
              "orderIndex": 626,
              "check": "false",
              "title": "应单新增",
              "value": "BatPreOrderAdd",
              "isEnd": "1"
            },
            {
              "path": "BatPreOrderDel",
              "code": "",
              "orderIndex": 627,
              "check": "false",
              "title": "应单删除",
              "value": "BatPreOrderDel",
              "isEnd": "1"
            },
            {
              "path": "BatPreOrderUpdate",
              "code": "",
              "orderIndex": 628,
              "check": "false",
              "title": "应单修改",
              "value": "BatPreOrderUpdate",
              "isEnd": "1"
            },
            {
              "path": "GoodsMatchListQry",
              "code": "",
              "orderIndex": 629,
              "check": "false",
              "title": "自动撮合",
              "value": "GoodsMatchListQry",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "BatGoodsStateUpdate",
              "code": "",
              "orderIndex": 621,
              "check": "false",
              "title": "发布状态修改",
              "value": "BatGoodsStateUpdate",
              "isEnd": "1"
            },
            {
              "path": "/commerce/listPayable",
              "code": "",
              "orderIndex": 621,
              "check": "false",
              "title": "挂单应单",
              "value": "listPayable",
              "isEnd": "0"
            },
            {
              "path": "BatGoodsAdd",
              "code": "",
              "orderIndex": 622,
              "check": "false",
              "title": "挂单新增",
              "value": "BatGoodsAdd",
              "isEnd": "1"
            },
            {
              "path": "BatGoodsDel",
              "code": "",
              "orderIndex": 623,
              "check": "false",
              "title": "挂单删除",
              "value": "BatGoodsDel",
              "isEnd": "1"
            },
            {
              "path": "BatGoodsUpdate",
              "code": " ",
              "orderIndex": 624,
              "check": "false",
              "title": "挂单修改",
              "value": "BatGoodsUpdate",
              "isEnd": "1"
            },
            {
              "path": "BatGoodsUpdateByState",
              "code": "",
              "orderIndex": 625,
              "check": "false",
              "title": "挂单应单撤销",
              "value": "BatGoodsUpdateByState",
              "isEnd": "1"
            },
            {
              "path": "BatPreOrderAdd",
              "code": "",
              "orderIndex": 626,
              "check": "false",
              "title": "应单新增",
              "value": "BatPreOrderAdd",
              "isEnd": "1"
            },
            {
              "path": "BatPreOrderDel",
              "code": "",
              "orderIndex": 627,
              "check": "false",
              "title": "应单删除",
              "value": "BatPreOrderDel",
              "isEnd": "1"
            },
            {
              "path": "BatPreOrderUpdate",
              "code": "",
              "orderIndex": 628,
              "check": "false",
              "title": "应单修改",
              "value": "BatPreOrderUpdate",
              "isEnd": "1"
            },
            {
              "path": "GoodsMatchListQry",
              "code": "",
              "orderIndex": 629,
              "check": "false",
              "title": "自动撮合",
              "value": "GoodsMatchListQry",
              "isEnd": "1"
            },
            {
              "path": "/commerce/listPayable/createListModfi",
              "code": "",
              "orderIndex": 640,
              "check": "false",
              "title": "挂单新建修改",
              "value": "commerce_createListModfi",
              "isEnd": "0"
            },
            {
              "path": "/commerce/listPayable/detailsInvoice",
              "code": "",
              "orderIndex": 650,
              "check": "false",
              "title": "已发布挂单详情",
              "value": "commerce_detailsListInvoice",
              "isEnd": "0"
            },
            {
              "path": "/commerce/listPayable/myAnswerList",
              "code": "",
              "orderIndex": 660,
              "check": "false",
              "title": "应单",
              "value": "commerce_myAnswerList",
              "isEnd": "0"
            },
            {
              "path": "/commerce/listQuery",
              "code": "",
              "orderIndex": 670,
              "check": "false",
              "title": "挂单查询",
              "value": "listQuery",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 620,
          "check": "false",
          "title": "挂单应单",
          "value": "commerce_listPayable",
          "isEnd": "0"
        },
        {
          "path": "/commerce/directionalTrading",
          "btnAuthList": [
            {
              "path": "DirBatGoodsAdd",
              "code": "",
              "orderIndex": 681,
              "check": "false",
              "title": "定向交易挂单新增",
              "value": "DirBatGoodsAdd",
              "isEnd": "1"
            },
            {
              "path": "DirBatGoodsStateUpdate",
              "code": " ",
              "orderIndex": 682,
              "check": "false",
              "title": "定向交易挂单发布状态修改",
              "value": "DirBatGoodsStateUpdate",
              "isEnd": "1"
            },
            {
              "path": "DirBatGoodsUpdate",
              "code": "",
              "orderIndex": 683,
              "check": "false",
              "title": "定向交易挂单修改",
              "value": "DirBatGoodsUpdate",
              "isEnd": "1"
            },
            {
              "path": "DirBatPreOrderAdd",
              "code": "",
              "orderIndex": 684,
              "check": "false",
              "title": "定向交易应单新增",
              "value": "DirBatPreOrderAdd",
              "isEnd": "1"
            },
            {
              "path": "DirBatPreOrderDel",
              "code": "",
              "orderIndex": 685,
              "check": "false",
              "title": "定向交易应单删除",
              "value": "DirBatPreOrderDel",
              "isEnd": "1"
            },
            {
              "path": "DirBatPreOrderUpdate",
              "code": "",
              "orderIndex": 686,
              "check": "false",
              "title": "定向交易应单修改",
              "value": "DirBatPreOrderUpdate",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "DirBatGoodsAdd",
              "code": "",
              "orderIndex": 681,
              "check": "false",
              "title": "定向交易挂单新增",
              "value": "DirBatGoodsAdd",
              "isEnd": "1"
            },
            {
              "path": "DirBatGoodsStateUpdate",
              "code": " ",
              "orderIndex": 682,
              "check": "false",
              "title": "定向交易挂单发布状态修改",
              "value": "DirBatGoodsStateUpdate",
              "isEnd": "1"
            },
            {
              "path": "DirBatGoodsUpdate",
              "code": "",
              "orderIndex": 683,
              "check": "false",
              "title": "定向交易挂单修改",
              "value": "DirBatGoodsUpdate",
              "isEnd": "1"
            },
            {
              "path": "DirBatPreOrderAdd",
              "code": "",
              "orderIndex": 684,
              "check": "false",
              "title": "定向交易应单新增",
              "value": "DirBatPreOrderAdd",
              "isEnd": "1"
            },
            {
              "path": "DirBatPreOrderDel",
              "code": "",
              "orderIndex": 685,
              "check": "false",
              "title": "定向交易应单删除",
              "value": "DirBatPreOrderDel",
              "isEnd": "1"
            },
            {
              "path": "DirBatPreOrderUpdate",
              "code": "",
              "orderIndex": 686,
              "check": "false",
              "title": "定向交易应单修改",
              "value": "DirBatPreOrderUpdate",
              "isEnd": "1"
            },
            {
              "path": "/commerce/directionalTrading",
              "code": "",
              "orderIndex": 690,
              "check": "false",
              "title": "定向交易",
              "value": "directionalTrading",
              "isEnd": "0"
            },
            {
              "path": "/commerce/directionalTrading/newTransactionModifi",
              "code": "",
              "orderIndex": 700,
              "check": "false",
              "title": "定向交易新建修改",
              "value": "commerce_newTransactionModifi",
              "isEnd": "0"
            },
            {
              "path": "/commerce/directionalTrading/transactionDetails",
              "code": "",
              "orderIndex": 710,
              "check": "false",
              "title": "定向交易详情",
              "value": "commerce_transactionDetails",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "1",
          "orderIndex": 680,
          "check": "false",
          "title": "定向交易",
          "value": "commerce_directionalTrading",
          "isEnd": "0"
        },
        {
          "path": "/commerce/bidAuction",
          "btnAuthList": [
            {
              "path": "BatBidProjectInfoPub",
              "code": "   ",
              "orderIndex": 671,
              "check": "false",
              "title": "竞买竞卖交易发布",
              "value": "BatBidProjectInfoPub",
              "isEnd": "1"
            },
            {
              "path": "BatBidProjectInfoUpd",
              "code": "",
              "orderIndex": 672,
              "check": "false",
              "title": "竞买竞卖修改",
              "value": "BatBidProjectInfoUpd",
              "isEnd": "1"
            },
            {
              "path": "BatBidProjectInfoUpdState",
              "code": "",
              "orderIndex": 673,
              "check": "false",
              "title": "竞买竞卖根据时间修改状态",
              "value": "BatBidProjectInfoUpdState",
              "isEnd": "1"
            },
            {
              "path": "BatOrderAddById",
              "code": "",
              "orderIndex": 674,
              "check": "false",
              "title": "竞买竞卖合同自动生成",
              "value": "BatOrderAddById",
              "isEnd": "1"
            },
            {
              "path": "BatBidPriceInfoAdd",
              "code": "",
              "orderIndex": 687,
              "check": "false",
              "title": "竞买竞卖竞价新增",
              "value": "BatBidPriceInfoAdd",
              "isEnd": "1"
            },
            {
              "path": "BatBidProjectInfoAdd",
              "code": "",
              "orderIndex": 688,
              "check": "false",
              "title": "竞买竞卖新增",
              "value": "BatBidProjectInfoAdd",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "BatBidProjectInfoPub",
              "code": "   ",
              "orderIndex": 671,
              "check": "false",
              "title": "竞买竞卖交易发布",
              "value": "BatBidProjectInfoPub",
              "isEnd": "1"
            },
            {
              "path": "BatBidProjectInfoUpd",
              "code": "",
              "orderIndex": 672,
              "check": "false",
              "title": "竞买竞卖修改",
              "value": "BatBidProjectInfoUpd",
              "isEnd": "1"
            },
            {
              "path": "BatBidProjectInfoUpdState",
              "code": "",
              "orderIndex": 673,
              "check": "false",
              "title": "竞买竞卖根据时间修改状态",
              "value": "BatBidProjectInfoUpdState",
              "isEnd": "1"
            },
            {
              "path": "BatOrderAddById",
              "code": "",
              "orderIndex": 674,
              "check": "false",
              "title": "竞买竞卖合同自动生成",
              "value": "BatOrderAddById",
              "isEnd": "1"
            },
            {
              "path": "BatBidPriceInfoAdd",
              "code": "",
              "orderIndex": 687,
              "check": "false",
              "title": "竞买竞卖竞价新增",
              "value": "BatBidPriceInfoAdd",
              "isEnd": "1"
            },
            {
              "path": "BatBidProjectInfoAdd",
              "code": "",
              "orderIndex": 688,
              "check": "false",
              "title": "竞买竞卖新增",
              "value": "BatBidProjectInfoAdd",
              "isEnd": "1"
            },
            {
              "path": "/commerce/bidAuction",
              "code": "",
              "orderIndex": 730,
              "check": "false",
              "title": "竞买竞卖",
              "value": "bidAuction",
              "isEnd": "0"
            },
            {
              "path": "/commerce/bidAuction/newBidModifi",
              "code": "",
              "orderIndex": 740,
              "check": "false",
              "title": "竞价新建页面修改",
              "value": "commerce_newBidModifi",
              "isEnd": "0"
            },
            {
              "path": "/commerce/bidAuction/bidRecord",
              "code": "",
              "orderIndex": 750,
              "check": "false",
              "title": "竞价记录详情页面",
              "value": "bidRecord",
              "isEnd": "0"
            },
            {
              "path": "/commerce/bidAuction/MyParticipateBid",
              "code": "",
              "orderIndex": 760,
              "check": "false",
              "title": "竞买竞卖-我参与的",
              "value": "myParticipateBid",
              "isEnd": "0"
            },
            {
              "path": "/commerce/bidAuction/biddingNotice",
              "code": "",
              "orderIndex": 770,
              "check": "false",
              "title": "竞价公告页",
              "value": "commerce_biddingNotice",
              "isEnd": "0"
            },
            {
              "path": "/commerce/bidAuction/participatingBidding",
              "code": "",
              "orderIndex": 780,
              "check": "false",
              "title": "参与竞价",
              "value": "commerce_participatingBidding",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 720,
          "check": "false",
          "title": "竞买竞卖",
          "value": "commerce_bidAuction",
          "isEnd": "0"
        },
        {
          "path": "/commerce/contracManagement",
          "btnAuthList": [
            {
              "path": "BatOrderPayment",
              "code": "",
              "orderIndex": 791,
              "check": "false",
              "title": "合同支付",
              "value": "BatOrderPayment",
              "isEnd": "1"
            },
            {
              "path": "SignaContract",
              "code": "",
              "orderIndex": 792,
              "check": "false",
              "title": "商贸合同签订",
              "value": "SignaContract",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "BatOrderPayment",
              "code": "",
              "orderIndex": 791,
              "check": "false",
              "title": "合同支付",
              "value": "BatOrderPayment",
              "isEnd": "1"
            },
            {
              "path": "SignaContract",
              "code": "",
              "orderIndex": 792,
              "check": "false",
              "title": "商贸合同签订",
              "value": "SignaContract",
              "isEnd": "1"
            },
            {
              "path": "/commerce/contracManagement",
              "code": "",
              "orderIndex": 800,
              "check": "false",
              "title": "合同管理",
              "value": "commerce_contract",
              "isEnd": "0"
            },
            {
              "path": "/commerce/contracManagement/contractConfirm",
              "code": "",
              "orderIndex": 810,
              "check": "false",
              "title": "合同确认",
              "value": "commerce_contractConfirm",
              "isEnd": "0"
            },
            {
              "path": "/commerce/contracManagement/historicalContract",
              "code": "",
              "children": [
                {
                  "path": "/commerce/contracManagement/detilContract",
                  "code": "",
                  "orderIndex": 830,
                  "check": "false",
                  "title": "详情合同",
                  "value": "commerce_detilContract",
                  "isEnd": "0"
                }
              ],
              "nextIsButton": "0",
              "orderIndex": 820,
              "check": "false",
              "title": "合同",
              "value": "commerce_historicalContract",
              "isEnd": "0"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 790,
          "check": "false",
          "title": "合同管理",
          "value": "contracManagement",
          "isEnd": "0"
        }
      ],
      "nextIsButton": "0",
      "orderIndex": 590,
      "check": "false",
      "title": "商贸交易",
      "value": "commerce",
      "isEnd": "0"
    },
    {
      "path": "/complaintsSuggestions",
      "btnAuthList": [
        {
          "path": "SuggestInfoAdd",
          "code": "",
          "orderIndex": 841,
          "check": "false",
          "title": "新增",
          "value": "SuggestInfoAdd",
          "isEnd": "1"
        },
        {
          "path": "SuggestInfoListQry",
          "code": " ",
          "orderIndex": 842,
          "check": "false",
          "title": "投诉建议历史查询",
          "value": "complaintsSugges",
          "isEnd": "1"
        }
      ],
      "code": "",
      "children": [
        {
          "path": "SuggestInfoAdd",
          "code": "",
          "orderIndex": 841,
          "check": "false",
          "title": "新增",
          "value": "SuggestInfoAdd",
          "isEnd": "1"
        },
        {
          "path": "SuggestInfoListQry",
          "code": " ",
          "orderIndex": 842,
          "check": "false",
          "title": "投诉建议历史查询",
          "value": "complaintsSugges",
          "isEnd": "1"
        }
      ],
      "nextIsButton": "1",
      "orderIndex": 840,
      "check": "false",
      "title": "投诉与建议",
      "value": "complaintsSuggestions",
      "isEnd": "0"
    },
    {
      "path": "/settings",
      "code": "",
      "children": [
        {
          "path": "/settings/userInfo",
          "btnAuthList": [
            {
              "path": "UserInfoUpd",
              "code": "",
              "orderIndex": 870,
              "check": "false",
              "title": "修改",
              "value": "UserInfoUpd",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "/settings/userInfo",
              "code": "",
              "orderIndex": 865,
              "check": "false",
              "title": "修改",
              "value": "userInfoCrd",
              "isEnd": "0"
            },
            {
              "path": "UserInfoUpd",
              "code": "",
              "orderIndex": 870,
              "check": "false",
              "title": "修改",
              "value": "UserInfoUpd",
              "isEnd": "1"
            }
          ],
          "nextIsButton": "1",
          "orderIndex": 860,
          "check": "false",
          "title": "用户基本信息",
          "value": "userInfo",
          "isEnd": "0"
        },
        {
          "path": "/settings/enterprise",
          "btnAuthList": [
            {
              "path": "EnterpriseInfoUpd",
              "code": "",
              "orderIndex": 890,
              "check": "false",
              "title": "修改",
              "value": "EnterpriseInfoUpd",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "/settings/enterprise",
              "code": "",
              "orderIndex": 885,
              "check": "false",
              "title": "企业基本信息",
              "value": "enterprise",
              "isEnd": "0"
            },
            {
              "path": "EnterpriseInfoUpd",
              "code": "",
              "orderIndex": 890,
              "check": "false",
              "title": "修改",
              "value": "EnterpriseInfoUpd",
              "isEnd": "1"
            }
          ],
          "nextIsButton": "1",
          "orderIndex": 880,
          "check": "false",
          "title": "企业基本信息",
          "value": "EnterpriseInfo",
          "isEnd": "0"
        },
        {
          "path": "/settings/producted",
          "btnAuthList": [
            {
              "path": "ProductDemandAdd",
              "code": " ",
              "orderIndex": 910,
              "check": "false",
              "title": "产品需求新建",
              "value": "ProductDemandAdd",
              "isEnd": "1"
            },
            {
              "path": "ProductDemandUpd",
              "code": "",
              "orderIndex": 920,
              "check": "false",
              "title": "产品需求修改、删除",
              "value": "ProductDemandUpd",
              "isEnd": "1"
            },
            {
              "path": "ProductSupplyAdd",
              "code": " ",
              "orderIndex": 930,
              "check": "false",
              "title": "产品供应新建",
              "value": "ProductSupplyAdd",
              "isEnd": "1"
            },
            {
              "path": "ProductSupplyUpd",
              "code": "",
              "orderIndex": 940,
              "check": "false",
              "title": "产品供应修改",
              "value": "ProductSupplyUpd",
              "isEnd": "1"
            },
            {
              "path": "ProductSupplyDelFlagUpd",
              "code": "",
              "orderIndex": 950,
              "check": "false",
              "title": "产品供应删除",
              "value": "ProductSupplyDelFlagUpd",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "ProductDemandAdd",
              "code": " ",
              "orderIndex": 910,
              "check": "false",
              "title": "产品需求新建",
              "value": "ProductDemandAdd",
              "isEnd": "1"
            },
            {
              "path": "ProductDemandUpd",
              "code": "",
              "orderIndex": 920,
              "check": "false",
              "title": "产品需求修改、删除",
              "value": "ProductDemandUpd",
              "isEnd": "1"
            },
            {
              "path": "ProductSupplyAdd",
              "code": " ",
              "orderIndex": 930,
              "check": "false",
              "title": "产品供应新建",
              "value": "ProductSupplyAdd",
              "isEnd": "1"
            },
            {
              "path": "ProductSupplyUpd",
              "code": "",
              "orderIndex": 940,
              "check": "false",
              "title": "产品供应修改",
              "value": "ProductSupplyUpd",
              "isEnd": "1"
            },
            {
              "path": "/settings/producted",
              "code": "",
              "orderIndex": 945,
              "check": "false",
              "title": "产品供需信息",
              "value": "product",
              "isEnd": "0"
            },
            {
              "path": "/settings/productdemand",
              "code": "",
              "orderIndex": 946,
              "check": "false",
              "title": "产品需求信息",
              "value": "productdemand",
              "isEnd": "0"
            },
            {
              "path": "/settings/productsupply",
              "code": "",
              "orderIndex": 947,
              "check": "false",
              "title": "产品供应信息",
              "value": "productsupply",
              "isEnd": "0"
            },
            {
              "path": "ProductSupplyDelFlagUpd",
              "code": "",
              "orderIndex": 950,
              "check": "false",
              "title": "产品供应删除",
              "value": "ProductSupplyDelFlagUpd",
              "isEnd": "1"
            }
          ],
          "nextIsButton": "1",
          "orderIndex": 900,
          "check": "false",
          "title": "产品供需信息",
          "value": "productInfo",
          "isEnd": "0"
        },
        {
          "path": "/settings/frequently",
          "btnAuthList": [
            {
              "path": "ConsigneeAddrAdd",
              "code": "",
              "orderIndex": 970,
              "check": "false",
              "title": "新建",
              "value": "ConsigneeAddrAdd",
              "isEnd": "1"
            },
            {
              "path": "ConsigneeAddrUpd",
              "code": "",
              "orderIndex": 980,
              "check": "false",
              "title": "修改",
              "value": "ConsigneeAddrUpd",
              "isEnd": "1"
            },
            {
              "path": "ConsigneeAddrSetDefault",
              "code": "",
              "orderIndex": 990,
              "check": "false",
              "title": "设为默认",
              "value": "ConsigneeAddrSetDefault",
              "isEnd": "1"
            },
            {
              "path": "ConsigneeAddrListUpd",
              "code": "",
              "orderIndex": 1000,
              "check": "false",
              "title": "删除",
              "value": "ConsigneeAddrListUpd",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "ConsigneeAddrAdd",
              "code": "",
              "orderIndex": 970,
              "check": "false",
              "title": "新建",
              "value": "ConsigneeAddrAdd",
              "isEnd": "1"
            },
            {
              "path": "ConsigneeAddrUpd",
              "code": "",
              "orderIndex": 980,
              "check": "false",
              "title": "修改",
              "value": "ConsigneeAddrUpd",
              "isEnd": "1"
            },
            {
              "path": "/settings/frequently",
              "code": "",
              "orderIndex": 985,
              "check": "false",
              "title": "新建",
              "value": "frequently",
              "isEnd": "0"
            },
            {
              "path": "ConsigneeAddrSetDefault",
              "code": "",
              "orderIndex": 990,
              "check": "false",
              "title": "设为默认",
              "value": "ConsigneeAddrSetDefault",
              "isEnd": "1"
            },
            {
              "path": "ConsigneeAddrListUpd",
              "code": "",
              "orderIndex": 1000,
              "check": "false",
              "title": "删除",
              "value": "ConsigneeAddrListUpd",
              "isEnd": "1"
            }
          ],
          "nextIsButton": "1",
          "orderIndex": 960,
          "check": "false",
          "title": "发收信息",
          "value": "setting_frequently",
          "isEnd": "0"
        },
        {
          "path": "/settings/smsCustom",
          "code": "",
          "orderIndex": 1010,
          "check": "false",
          "title": "短信定制",
          "value": "smsCustom",
          "isEnd": "0"
        },
        {
          "path": "/settings/passwordModif",
          "btnAuthList": [
            {
              "path": "PasswordModify",
              "code": "",
              "orderIndex": 1030,
              "check": "false",
              "title": "修改",
              "value": "PasswordModify",
              "isEnd": "1"
            }
          ],
          "code": "",
          "children": [
            {
              "path": "/settings/passwordModif",
              "code": "",
              "orderIndex": 1025,
              "check": "false",
              "title": "密码修改",
              "value": "passwordModif",
              "isEnd": "0"
            },
            {
              "path": "PasswordModify",
              "code": "",
              "orderIndex": 1030,
              "check": "false",
              "title": "修改",
              "value": "PasswordModify",
              "isEnd": "1"
            }
          ],
          "nextIsButton": "0",
          "orderIndex": 1020,
          "check": "false",
          "title": "密码修改",
          "value": "password",
          "isEnd": "0"
        }
      ],
      "nextIsButton": "0",
      "orderIndex": 850,
      "check": "false",
      "title": "个人设置",
      "value": "settings",
      "isEnd": "0"
    }
  ]
}
